import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faBullseye, faUserTie, faUsers, faGraduationCap, faBuilding } from '@fortawesome/free-solid-svg-icons';
import strukturOrganisasi from '../data/strukturOrganisasi';
import '../styles/Profil.css';

const Profil = () => {
  // Pisahkan ketua dan wakil ketua
  const ketua = strukturOrganisasi.pimpinan.find(p => p.urutan === 1);
  const wakilKetua = strukturOrganisasi.pimpinan.filter(p => p.urutan > 1);

  return (
    <div className="profil-page">
      {/* Hero Section */}
      <section className="profil-hero">
        <div className="container">
          <h1>Profil STIKES Baramuli</h1>
          <p>
            Mengenal lebih dekat Sekolah Tinggi Ilmu Kesehatan Baramuli, 
            visi misi, dan struktur organisasi kami
          </p>
        </div>
      </section>

      {/* Visi Misi Section */}
      <section className="visi-misi-section">
        <div className="container">
          <div className="visi-misi-grid">
            <div className="visi-card">
              <h2><FontAwesomeIcon icon={faEye} /> Visi</h2>
              <p>
                Menjadi institusi pendidikan tinggi kesehatan yang unggul, 
                berkarakter, dan berdaya saing dalam menghasilkan tenaga 
                kesehatan profesional yang beriman, berilmu, dan berakhlak 
                mulia di tingkat nasional pada tahun 2030.
              </p>
            </div>
            <div className="misi-card">
              <h2><FontAwesomeIcon icon={faBullseye} /> Misi</h2>
              <ol>
                <li>
                  Menyelenggarakan pendidikan tinggi kesehatan yang berkualitas 
                  berbasis kompetensi dan karakter.
                </li>
                <li>
                  Melaksanakan penelitian yang inovatif dan bermanfaat bagi 
                  pengembangan ilmu kesehatan.
                </li>
                <li>
                  Melaksanakan pengabdian kepada masyarakat yang berkontribusi 
                  pada peningkatan derajat kesehatan.
                </li>
                <li>
                  Mengembangkan kerjasama dengan berbagai pihak dalam dan 
                  luar negeri.
                </li>
                <li>
                  Menciptakan suasana akademik yang kondusif dan berkarakter.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>

      {/* Struktur Organisasi Section - Modern Org Chart */}
      <section className="struktur-section">
        <div className="container">
          <div className="section-title">
            <h2>Struktur Organisasi</h2>
            <p>Bagan organisasi STIKES Baramuli</p>
          </div>

          {/* Org Chart Container */}
          <div className="org-chart">
            
            {/* Level 1 - Ketua */}
            <div className="org-level org-level-1">
              {ketua && (
                <div className="org-card org-card-ketua">
                  <div className="org-card-icon">
                    <FontAwesomeIcon icon={faUserTie} />
                  </div>
                  <div className="org-card-content">
                    <h4>{ketua.nama}</h4>
                    <span className="org-jabatan">{ketua.jabatan}</span>
                  </div>
                </div>
              )}
            </div>

            {/* Connector Line */}
            <div className="org-connector">
              <div className="org-line-vertical"></div>
              <div className="org-line-horizontal"></div>
            </div>

            {/* Level 2 - Wakil Ketua */}
            <div className="org-level org-level-2">
              {wakilKetua.map((wakil) => (
                <div key={wakil.id} className="org-card org-card-wakil">
                  <div className="org-card-icon wakil">
                    <FontAwesomeIcon icon={faUserTie} />
                  </div>
                  <div className="org-card-content">
                    <h4>{wakil.nama}</h4>
                    <span className="org-jabatan">{wakil.jabatan}</span>
                    <span className="org-unit">{wakil.unit_kerja}</span>
                  </div>
                </div>
              ))}
            </div>

            {/* Connector */}
            <div className="org-connector">
              <div className="org-line-vertical"></div>
            </div>

            {/* Level 3 - Program Studi */}
            <div className="org-section">
              <div className="org-section-header">
                <FontAwesomeIcon icon={faGraduationCap} />
                <h3>Program Studi</h3>
              </div>
              <div className="org-level org-level-3">
                {strukturOrganisasi.kepalaProgramStudi.map((kaprodi) => (
                  <div key={kaprodi.id} className="org-card org-card-prodi">
                    <div className="org-card-content">
                      <span className="org-unit-badge">{kaprodi.unit_kerja}</span>
                      <h4>{kaprodi.nama}</h4>
                      <span className="org-jabatan">{kaprodi.jabatan}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Level 4 - Unit & Lembaga */}
            <div className="org-section">
              <div className="org-section-header">
                <FontAwesomeIcon icon={faBuilding} />
                <h3>Unit & Lembaga</h3>
              </div>
              <div className="org-level org-level-4">
                {strukturOrganisasi.kepalaUnit.map((unit) => (
                  <div key={unit.id} className="org-card org-card-unit">
                    <div className="org-card-content">
                      <span className="org-unit-badge">{unit.unit_kerja}</span>
                      <h4>{unit.nama}</h4>
                      <span className="org-jabatan">{unit.jabatan}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Level 5 - Staff */}
            <div className="org-section org-section-staff">
              <div className="org-section-header">
                <FontAwesomeIcon icon={faUsers} />
                <h3>Staff & Tenaga Kependidikan</h3>
              </div>
              <div className="org-staff-grid">
                {strukturOrganisasi.staff.map((staf) => (
                  <div key={staf.id} className="org-staff-card">
                    <div className="org-staff-content">
                      <h4>{staf.nama}</h4>
                      <span className="org-jabatan">{staf.jabatan}</span>
                      <span className="org-unit">{staf.unit_kerja}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Profil;
